<template>
  <div>
    <el-form :inline="true" class="form" :model="ruleForm">
      <el-form-item label="创建时间" class="item-date">
        <el-date-picker
          v-model="ruleForm.datePickerModel"
          :editable="false"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          prefix-icon=""
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="服务商主体">
        <el-select v-model="ruleForm.merchantType" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label"> </el-option>
        </el-select>
      </el-form-item>
      <div class="search-type">
        <div>
          <el-form-item label="申请状态">
            <el-select v-model="ruleForm.status" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="searchData">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="addMerchants">+ 新增商户</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    conditionInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        datePickerModel: [],
        merchantType: '',
        status: '',
      },
      options: [
        {
          value: '1',
          label: '美好西安',
        },
        {
          value: '2',
          label: '美好北京',
        },
      ],
      typeList: [
        {
          value: '0',
          label: '待提交',
        },
        {
          value: '1',
          label: '待审核',
        },
        {
          value: '2',
          label: '待验证',
        },
        {
          value: '3',
          label: '待签约',
        },
        {
          value: '4',
          label: '已驳回',
        },
        {
          value: '5',
          label: '已完成',
        },
        {
          value: '6',
          label: '开通权限中',
        },
      ],
      value: '',
      tabPosition: '',
      search: '',
    };
  },

  watch: {
    conditionInfo: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = JSON.parse(JSON.stringify(data));
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    // 选择时间范围
    selectTime(index) {
      this.$emit('selectTime', index);
    },
    searchData() {
      console.log(this.ruleForm);
      this.$emit('searchData', this.ruleForm);
    },
    reset() {
      this.$emit('reset');
    },
    addMerchants() {
      this.$router.push({
        path: '/merchants/facilitator',
        query: { type: 'add' },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.form {
  position: relative;
  padding: 20px;
  padding-bottom: 0;
  box-sizing: border-box;
  background: @bg-white;
  .el-form-item {
    margin-right: 30px;
  }
  // /deep/.el-input--suffix .el-input__inner {
  //   width: 137px;
  // }
  /deep/ .el-input__inner {
    width: 215px;
  }
  .item-date {
    /deep/.el-form-item__content {
      width: 280px;
    }
    /deep/.el-date-editor--daterange {
      width: 280px;
    }
  }
  .search-type {
    display: flex;
    justify-content: space-between;
  }
}
</style>
